import { render, staticRenderFns } from "./bag-model-prescription.vue?vue&type=template&id=4c66bf6a&scoped=true&lang=pug&"
import script from "./bag-model-prescription.vue?vue&type=script&lang=ts&"
export * from "./bag-model-prescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c66bf6a",
  null
  
)

export default component.exports